import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
// import { Button } from 'antd'
import QRCodeManager from 'qrcode.react'
import WhiteSpace from 'components/WhiteSpace'
import { Button } from 'antd'
import { intl, recordCountlyEvent } from 'utils'
import { Loading } from 'components'

const IMAGES = {
  payby: require('./images/PayBy Pay.png'),
  'totok-pay': require('./images/ToTok Pay.png'),
  'botim-pay': require('./images/BOTIM Pay.png'),
}

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCalledDeeplink: false,
    }
  }

  handleSubmit = () => {
    const { submit, pageName, ...data } = this.props
    console.log(pageName)
    pageName &&
      recordCountlyEvent({
        page_name: pageName,
        event_name: 'pull',
        element_name: 'pull_pay',
        biz_tags: {
          channel: data.tabName.toLowerCase().replace(' ', '_'),
          trade_voucher_no: sessionStorage.orderNo
        }
      })
    this.setState({
      isCalledDeeplink: true,
    })
    submit({
      ...data,
      method: 'PAY_WITH_DEEPLINK',
    })
  }

  render() {
    const {
      siteConfig,
      scanPayUrl,
      hostApp,
      tabName,
      introduceMediaUrl,
      iconUrl,
      optAppItems = [],
      pageName
    } = this.props
    console.log(this.props)
    const { isCalledDeeplink } = this.state
    if (siteConfig.isMobile) {
      return (
        <div className={classes.componentsPaymentMethodsApp}>
          {!isCalledDeeplink && (
            <Button
              block
              loading={isCalledDeeplink}
              type='primary'
              size='large'
              onClick={this.handleSubmit}
            >
              {tabName}
            </Button>
          )}
          {isCalledDeeplink && (
            <React.Fragment>
              <div style={{ height: '200px' }}>
                <Loading inlineNormalLoading>
                  {intl().formatMessage(messages.Processing)}
                </Loading>
              </div>
              <WhiteSpace />
              <Button
                block
                type='primary-secondary'
                size='large'
                onClick={() => {
                  pageName &&
                    recordCountlyEvent({
                      page_name: pageName,
                      event_name: 'click',
                      element_name: 'retry',
                      biz_tags: {
                        trade_voucher_no: sessionStorage.orderNo
                      }
                    })
                  this.setState({ isCalledDeeplink: false })
                }}
              >
                <span>
                  {intl().formatMessage(messages.BacktoRetry)}
                </span>
              </Button>
            </React.Fragment>
          )}
          <WhiteSpace size='xl' />
          {optAppItems.indexOf('introduceMedia') > -1 && introduceMediaUrl && (
            <video className={classes.vedio} autoPlay muted loop playsInline>
              <source src={introduceMediaUrl} type='video/mp4' />
            </video>
          )}
          <WhiteSpace />
        </div>
      )
    }
    return (
      <div className={classes.componentsPaymentMethodsApp}>
        {scanPayUrl && (
          <QRCodeManager
            size={232}
            value={scanPayUrl}
            bgColor='transparent'
            imageSettings={{ src: iconUrl || IMAGES[hostApp], width: 24, height: 24, excavate: true }}
          />
        )}
        <div style={{ lineHeight: '24px' }}>
          <span
            className='iconfont iconSCANPAY font-24'
            style={{ verticalAlign: 'bottom' }}
          />{' '}
          {intl().formatMessage(messages.ScanandPayWith)}{' '}
          {tabName && tabName.replace(/ Pay$/, '')}
        </div>
        <WhiteSpace size='xl' />
        {optAppItems.indexOf('introduceMedia') > -1 && introduceMediaUrl && (
          <video className={classes.vedio} autoPlay muted loop playsInline>
            <source src={introduceMediaUrl} type='video/mp4' />
          </video>
        )}
        <WhiteSpace />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {}
)(App)
